module.exports = __webpack_public_path__ + "static/media/logo-saurus.c0c88723.png";